import client from './client'
import qs from 'qs'
/*
* params
*   type
*   url
*   data
* */
export default function (params) {
  const type = params.type ? params.type.toUpperCase() : 'GET'
  const data = params.data || {}
  const headers = params.headers || {}
  const {url} = params
  if (type === 'GET') {
    return client.get(url, {
      params: data,
      headers,
      paramsSerializer: (params) => {
        return qs.stringify(params, {indices: false})
      }
    })
  } else if (type === 'POST') {
    return client.post(url, data, { headers })
  } else if (type === 'PUT') {
    return client.put(url, data, { headers })
  } else if (type === 'DELETE') {
    return client.delete(url, data, { headers })
  } else if (type === 'PATCH') {
    return client.patch(url, data, { headers })
  }
}



// WEBPACK FOOTER //
// ./src/apis/admin-api/api.js